import { put, takeEvery, select } from 'redux-saga/effects';
import { createShippingGroup } from '../shipping/shippingSagas';
import { removeShippingGroup } from '../shipping/shippingModule';
import { itemForKey } from './lineItemSelectors';

import { REMOVE_LINE_ITEM, addOrUpdateLineItem, SAVE_LINE_ITEM } from './lineItemModule';

export function* saveLineItemSaga(action) {
    
    if (action.lineItem.id !== undefined) {
        const lineItem = yield select(itemForKey, action.lineItem.id);
        if (lineItem.shippingGroup !== undefined) {
            yield put(removeShippingGroup(lineItem.shippingGroup));
        }
    }

    if (action.lineItem.deliveryMethod === 'PHYSICAL') {
        const lineItem = yield createShippingGroup(action.lineItem);
        yield put(addOrUpdateLineItem(lineItem));
    } else {
        yield put(addOrUpdateLineItem(action.lineItem));
    }
}

export function* removeLineItemSaga(action) {
    if (action.lineItem.deliveryMethod === 'PHYSICAL') yield put(removeShippingGroup(action.lineItem.shippingGroup));
}

export function* lineItemWatcher() {
    yield takeEvery(SAVE_LINE_ITEM, saveLineItemSaga);
    yield takeEvery(REMOVE_LINE_ITEM, removeLineItemSaga);
}
